// extracted by mini-css-extract-plugin
export default {"table-cell-text":"style_table-cell-text__1TGo+"};